<div [class]="mixedMode() ? 'unified-tile-body h-full' : ''">
    <div class="grid grid-cols-12 gap-3 lg:gap-4 grid-flow-row-dense items-stretch ">
        @if (showSection(SectionId.STATS_SUMMARY_OVERVIEW)) {
        <div class="group relative border border-slate-200 dark:border-slate-700 p-4 bg-white/90 dark:bg-surface-1/60 backdrop-blur-sm rounded-xl"
            [ngClass]="getSectionColClass(SectionId.STATS_SUMMARY_OVERVIEW)"
            [style.order]="sectionOrder(SectionId.STATS_SUMMARY_OVERVIEW)">
            @if (!mixedMode() && canPinToCustomDashboard(SectionId.STATS_SUMMARY_OVERVIEW)) {
            <button type="button"
                (click)="addToCustomDashboard(SectionId.STATS_SUMMARY_OVERVIEW); $event.stopPropagation()"
                [disabled]="isAddingToCustomDashboard(SectionId.STATS_SUMMARY_OVERVIEW)"
                class="group/pin absolute cursor-pointer top-2 right-2 z-30 inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full border shadow-sm text-[11px] font-medium whitespace-nowrap opacity-0 translate-y-[-2px] group-hover:opacity-100 group-hover:translate-y-0 focus-visible:opacity-100 focus-visible:translate-y-0 transition-all duration-200 disabled:cursor-default"
                [ngClass]="isAddedToCustomDashboard(SectionId.STATS_SUMMARY_OVERVIEW)
        ? 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-rose-50 hover:text-rose-700 hover:border-rose-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800 dark:hover:bg-rose-900/30 dark:hover:text-rose-300 dark:hover:border-rose-800 !opacity-100 !translate-y-0'
        : 'bg-white/95 text-[#AD46FF] border-[#AD46FF]/30 hover:bg-violet-50 hover:border-[#AD46FF]/60 hover:shadow-md dark:bg-slate-800/95 dark:border-purple-500/40 dark:hover:bg-white/5'"
                [attr.aria-label]="isAddedToCustomDashboard(SectionId.STATS_SUMMARY_OVERVIEW) ? 'Remove from My Custom Dashboard' : 'Add to My Custom Dashboard'"
                [title]="isAddedToCustomDashboard(SectionId.STATS_SUMMARY_OVERVIEW) ? 'Click to remove from My Custom Dashboard' : 'Add to My Custom Dashboard'">
                @if (isAddingToCustomDashboard(SectionId.STATS_SUMMARY_OVERVIEW)) {
                <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                </svg>
                <span>{{ isAddedToCustomDashboard(SectionId.STATS_SUMMARY_OVERVIEW) ? 'Removing' : 'Adding'
                    }}&hellip;</span>
                } @else if (isAddedToCustomDashboard(SectionId.STATS_SUMMARY_OVERVIEW)) {
                <svg class="shrink-0 block group-hover/pin:hidden" xmlns="http://www.w3.org/2000/svg" width="11"
                    height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 6 9 17l-5-5" />
                </svg>
                <svg class="shrink-0 hidden group-hover/pin:block" xmlns="http://www.w3.org/2000/svg" width="11"
                    height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                </svg>
                <span
                    class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[220px] group-hover/pin:ml-0 focus-visible:max-w-[220px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Remove
                    from Custom Dashboard</span>
                } @else {
                <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                    <path d="M12 5v14" />
                </svg>
                <span
                    class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[200px] group-hover/pin:ml-0 focus-visible:max-w-[200px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Pin
                    to Custom Dashboard</span>
                }
            </button>
            }

            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-6 gap-4 h-full">
                @if (isLoadingByAdmin) {
                @for (i of [1,2,3,4,5,6]; track i) {
                <div
                    class="bg-white dark:bg-surface-2 rounded-[20px] px-3 py-2 2xl:px-5 2xl:py-4 border border-slate-200 dark:border-gray-700 shadow-sm animate-pulse flex items-center gap-3 lg:gap-4 h-[72px] lg:h-[96px]">
                    <div class="w-8 h-8 2xl:w-10 lg:h-10 rounded-xl bg-slate-100 dark:bg-slate-700/50 shrink-0"></div>
                    <div class="flex flex-col gap-2 flex-1">
                        <div class="h-3 w-20 bg-slate-100 dark:bg-slate-700/40 rounded"></div>
                        <div class="h-6 w-16 bg-slate-100 dark:bg-slate-700/60 rounded"></div>
                    </div>
                </div>
                }
                } @else {
                @for (card of statsRow()!.items; track card.label) {
                <div
                    class="bg-white dark:bg-surface-2 rounded-[20px] px-3 py-2 2xl:px-5 2xl:py-4 border border-slate-200 dark:border-gray-700 shadow-sm dark:shadow-none hover:shadow-md dark:hover:shadow-none transition-all duration-300 flex items-center gap-3 lg:gap-4 text-left">
                    <div
                        class="w-8 h-8 2xl:w-10 lg:h-10 rounded-xl flex items-center justify-center text-white shadow-lg dark:shadow-none {{card.iconBg}} {{card.shadow}} shrink-0 transition-transform hover:scale-105 duration-300">
                        <app-icon-v2 [name]="card.icon" [size]="20" class="lg:scale-110"></app-icon-v2>
                    </div>
                    <div class="flex flex-col h-full justify-center min-w-0 flex-1">
                        <app-tooltip [content]="card.label" class="max-w-max" [block]="true"
                            className="!w-auto whitespace-nowrap">
                            <p
                                class="text-[10px] lg:text-[11px] font-medium text-slate-500 dark:text-slate-400 tracking-wider mb-3 truncate w-auto">
                                {{card.label}}
                            </p>
                        </app-tooltip>
                        <app-tooltip [content]="card.value" class="max-w-max" [block]="true"
                            className="!w-auto whitespace-nowrap">
                            <h3
                                class="text-lg lg:text-2xl font-bold text-slate-900 dark:text-white leading-none tracking-tight truncate w-auto">
                                {{card.value}}</h3>
                        </app-tooltip>
                    </div>
                </div>
                }
                }
            </div>
        </div>
        }

        @for (detailSection of [
        { id: SectionId.TOP_PERFORMER, index: 0 },
        { id: SectionId.DUPLICATE_CRISIS, index: 1 },
        { id: SectionId.AVG_RECOVERY_PER_ADMIN, index: 2 }
        ]; track detailSection.id) {
        @let stat = detailedStatAt(detailSection.index);
        @if (showSection(detailSection.id)) {
        <div class="group relative" [ngClass]="getSectionColClass(detailSection.id)"
            [style.order]="sectionOrder(detailSection.id)">
            @if (!mixedMode() && canPinToCustomDashboard(detailSection.id)) {
            <button type="button" (click)="addToCustomDashboard(detailSection.id); $event.stopPropagation()"
                [disabled]="isAddingToCustomDashboard(detailSection.id)"
                class="group/pin absolute cursor-pointer top-2 right-2 z-30 inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full border shadow-sm text-[11px] font-medium whitespace-nowrap opacity-0 translate-y-[-2px] group-hover:opacity-100 group-hover:translate-y-0 focus-visible:opacity-100 focus-visible:translate-y-0 transition-all duration-200 disabled:cursor-default"
                [ngClass]="isAddedToCustomDashboard(detailSection.id)
        ? 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-rose-50 hover:text-rose-700 hover:border-rose-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800 dark:hover:bg-rose-900/30 dark:hover:text-rose-300 dark:hover:border-rose-800 !opacity-100 !translate-y-0'
        : 'bg-white/95 text-[#AD46FF] border-[#AD46FF]/30 hover:bg-violet-50 hover:border-[#AD46FF]/60 hover:shadow-md dark:bg-slate-800/95 dark:border-purple-500/40 dark:hover:bg-white/5'"
                [attr.aria-label]="isAddedToCustomDashboard(detailSection.id) ? 'Remove from My Custom Dashboard' : 'Add to My Custom Dashboard'"
                [title]="isAddedToCustomDashboard(detailSection.id) ? 'Click to remove from My Custom Dashboard' : 'Add to My Custom Dashboard'">
                @if (isAddingToCustomDashboard(detailSection.id)) {
                <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                </svg>
                <span>{{ isAddedToCustomDashboard(detailSection.id) ? 'Removing' : 'Adding' }}&hellip;</span>
                } @else if (isAddedToCustomDashboard(detailSection.id)) {
                <svg class="shrink-0 block group-hover/pin:hidden" xmlns="http://www.w3.org/2000/svg" width="11"
                    height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 6 9 17l-5-5" />
                </svg>
                <svg class="shrink-0 hidden group-hover/pin:block" xmlns="http://www.w3.org/2000/svg" width="11"
                    height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                </svg>
                <span
                    class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[220px] group-hover/pin:ml-0 focus-visible:max-w-[220px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Remove
                    from Custom Dashboard</span>
                } @else {
                <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                    <path d="M12 5v14" />
                </svg>
                <span
                    class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[200px] group-hover/pin:ml-0 focus-visible:max-w-[200px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Pin
                    to Custom Dashboard</span>
                }
            </button>
            }

            @if (isLoadingByAdmin || isLoadingDuplicatesSummary) {
            <div
                class="bg-white dark:bg-surface-2 rounded-[20px] p-4 border border-slate-200 dark:border-gray-700 shadow-sm animate-pulse h-[280px]">
            </div>
            } @else if (stat) {
            <div
                class="bg-white dark:bg-surface-2 rounded-[20px] p-4 border border-slate-200 dark:border-gray-700 shadow-sm dark:shadow-none hover:shadow-md dark:hover:shadow-none transition-all duration-300 flex flex-col h-full">
                <div class="mb-6">
                    <p class="text-xs font-medium text-slate-500 dark:text-slate-400 mb-1 tracking-wider text-left">
                        {{stat.title}}</p>
                    <div class="flex items-baseline gap-2">
                        <h3 class="text-3xl font-bold text-slate-800 dark:text-white leading-none">{{stat.mainValue}}
                        </h3>
                        @if (stat.subValue) {
                        <span class="text-sm text-slate-400 font-medium">{{stat.subValue}}</span>
                        }
                    </div>
                </div>
                <div class="flex-1 flex flex-col justify-end gap-3">
                    @for (item of stat.items; track item.label) {
                    <div
                        class="flex items-center justify-between p-4 border border-slate-100 dark:border-gray-700/50 rounded-xl bg-white dark:bg-surface-0/50">
                        <div class="flex items-center gap-3">
                            <div class="w-1 h-8 rounded-full {{item.barColor}} shrink-0"></div>
                            <span class="text-sm font-medium text-slate-600 dark:text-slate-400">{{item.label}}</span>
                        </div>
                        <span class="text-lg font-bold {{item.valueColor}} shrink-0">{{item.value}}</span>
                    </div>
                    }
                </div>
            </div>
            }
        </div>
        }
        }

        @for (item of orderedVisibleChartItems(); track item.id) {
        <div class="group relative" [ngClass]="getSectionColClass(chartSectionId(item.id))"
            [style.order]="sectionOrder(chartSectionId(item.id))">
            @if (!mixedMode() && canPinToCustomDashboard(chartSectionId(item.id))) {
            <button type="button" (click)="addToCustomDashboard(chartSectionId(item.id)); $event.stopPropagation()"
                [disabled]="isAddingToCustomDashboard(chartSectionId(item.id))"
                class="group/pin absolute cursor-pointer top-2 right-2 z-30 inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full border shadow-sm text-[11px] font-medium whitespace-nowrap opacity-0 translate-y-[-2px] group-hover:opacity-100 group-hover:translate-y-0 focus-visible:opacity-100 focus-visible:translate-y-0 transition-all duration-200 disabled:cursor-default"
                [ngClass]="isAddedToCustomDashboard(chartSectionId(item.id))
        ? 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-rose-50 hover:text-rose-700 hover:border-rose-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800 dark:hover:bg-rose-900/30 dark:hover:text-rose-300 dark:hover:border-rose-800 !opacity-100 !translate-y-0'
        : 'bg-white/95 text-[#AD46FF] border-[#AD46FF]/30 hover:bg-violet-50 hover:border-[#AD46FF]/60 hover:shadow-md dark:bg-slate-800/95 dark:border-purple-500/40 dark:hover:bg-white/5'"
                [attr.aria-label]="isAddedToCustomDashboard(chartSectionId(item.id)) ? 'Remove from My Custom Dashboard' : 'Add to My Custom Dashboard'"
                [title]="isAddedToCustomDashboard(chartSectionId(item.id)) ? 'Click to remove from My Custom Dashboard' : 'Add to My Custom Dashboard'">
                @if (isAddingToCustomDashboard(chartSectionId(item.id))) {
                <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                </svg>
                <span>{{ isAddedToCustomDashboard(chartSectionId(item.id)) ? 'Removing' : 'Adding' }}&hellip;</span>
                } @else if (isAddedToCustomDashboard(chartSectionId(item.id))) {
                <svg class="shrink-0 block group-hover/pin:hidden" xmlns="http://www.w3.org/2000/svg" width="11"
                    height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 6 9 17l-5-5" />
                </svg>
                <svg class="shrink-0 hidden group-hover/pin:block" xmlns="http://www.w3.org/2000/svg" width="11"
                    height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                </svg>
                <span
                    class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[220px] group-hover/pin:ml-0 focus-visible:max-w-[220px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Remove
                    from Custom Dashboard</span>
                } @else {
                <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                    <path d="M12 5v14" />
                </svg>
                <span
                    class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[200px] group-hover/pin:ml-0 focus-visible:max-w-[200px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Pin
                    to Custom Dashboard</span>
                }
            </button>
            }
            <div
                class="bg-white dark:bg-surface-2 rounded-[20px] p-5 border border-slate-200 dark:border-gray-700 shadow-sm dark:shadow-none flex flex-col h-full">
                <div class="mb-4">
                    <h3 class="text-lg font-bold text-slate-800 dark:text-white">{{item.title}}</h3>
                    <p class="text-xs font-medium text-slate-500 dark:text-slate-400">{{item.subtitle}}</p>
                </div>
                <div [style.height]="item.height !== 'auto' ? item.height : null"
                    class="w-full flex-1 flex flex-col relative min-h-[350px]">
                    @if (isLoading(item.id)) {
                    <app-individual-toaster fontSize="20px"
                        class="absolute inset-0 z-10 flex items-center justify-center rounded-[20px]"></app-individual-toaster>
                    }

                    @if (hasData(item.id)) {
                    @switch (item.id) {
                    @case ('duplicate-over-time') {
                    <app-multiple-bar [data1]="duplicateOverTimeData.data1" [data2]="duplicateOverTimeData.data2"
                        [data3]="duplicateOverTimeData.data3" [legendData]="chartLegendData" [colors]="chartColors"
                        [showLegends]="true" [showDynamicxAxisLabel]="true" valueKey="value" valueType="number"
                        [groupPadding]="0.2" [innerPadding]="0" [margin]="{top: 10, right: 10, bottom: 30, left: 30}"
                        [gap]="0" [fitBarsToWidth]="true" [tooltipData]="[
                                                { label: 'Total Null Entries', key: '_g0' },
                                                { label: 'Deletion Entries',   key: '_g1' },
                                                { label: 'Duplicate Entries',  key: '_g2' }
                                            ]" [maxBarWidth]="60" [height]="350" [showBarValues]="false"
                        [xAxisShowOnlyFirstLast]="true" [legendGap]="item.legendGap || 80" [showCard]="false"
                        [margin]="{top: 10, right: 10, bottom: 30, left: 30}">
                    </app-multiple-bar>
                    }
                    @case ('duplicate-yoy') {
                    <app-line-area-chart [series]="duplicateYoYData" [theme]="yoYTheme" [legend]="{ show: false }"
                        [xAxis]="{ show: true, showOnlyFirstLast: true, showAxisLine: false, showGrid: false }"
                        [dateUnit]="unit()" [margins]="{ left: 40, right: 20, top: 10, bottom: 40 }" [showCard]="false"
                        [expandMonthDomain]="false" [xAxisPadding]="15"></app-line-area-chart>
                    }
                    @case ('performance-distribution') {
                    <div class="flex-1 flex flex-col">
                        <app-isometric-bar [data]="performanceDistributionData" [barWidth]="45" [width]="600"
                            [height]="240" [barDepth]="18" [borderRadius]="12" [angle]="0"
                            [showLegend]="false"></app-isometric-bar>
                        <div class="grid grid-cols-3 gap-3 mb-3 mt-1 text-left">
                            @for (stat of performanceStats; track stat.label) {
                            <div
                                class="px-3 py-2 bg-slate-50 dark:bg-surface-0/50 rounded-xl border border-slate-100 dark:border-gray-700/50">
                                <p class="text-[10px] text-slate-500 font-medium mb-0.5">{{stat.label}}</p>
                                <h4 class="text-base font-bold text-slate-800 dark:text-white mb-0.5">{{stat.value}}
                                </h4>
                                <p class="text-[9px] text-slate-400 leading-none">{{stat.sub}}</p>
                            </div>
                            }
                        </div>
                        <div class="mt-auto pt-2.5 border-t border-slate-100 dark:border-gray-700/50 text-center">
                            <p class="text-[12px] text-slate-600 dark:text-slate-400 leading-relaxed">
                                <span class="font-bold text-slate-900 dark:text-slate-200">Decision Insight:</span>
                                {{decisionInsight}}
                            </p>
                        </div>
                    </div>
                    }
                    @case ('recovery-efficiency') {
                    <app-line-area-chart [series]="recoveryEfficiencyData" [theme]="recoveryEfficiencyTheme"
                        [legend]="{ show: true, position: 'bottom', markerStyle: 'circle' }"
                        [xAxis]="{ show: true, showOnlyFirstLast: true, showGrid: true, gridStyle: 'dashed' }"
                        [showPoints]="true" [areaOpacity]="0" [showValueLabels]="true" [dateUnit]="unit()"
                        [expandMonthDomain]="false" [xAxisPadding]="15" [showCard]="false"
                        [margins]="{ left: 40, right: 20, top: 10, bottom: 40 }"></app-line-area-chart>
                    }
                    @case ('repeat-pattern') {
                    <app-lollipop-chart [data]="repeatArrangementData" [lineData]="repeatArrangementLineData"
                        [legendLabel1]="'Contracts'" [legendLabel2]="'Contracts Success Rate %'" [showLegend]="true"
                        [showTooltip]="true" [minHeight]="item.minHeight || 300" [marginTop]="item.marginTop || 40"
                        [marginBottom]="item.marginBottom || 40"
                        [legendOffset]="item.legendOffset !== undefined ? item.legendOffset : 35"
                        valueFormat="number"></app-lollipop-chart>
                    }
                    @case ('admin-workload') {
                    <app-horizontal-bar-chart [data]="adminWorkloadData" [maxBarWidth]="40" [barHeight]="25"
                        [showLegend]="true" [legendItems]="adminWorkloadLegend" [showTooltip]="true"
                        [minHeight]="item.minHeight || 250" [marginTop]="item.marginTop || 30"
                        [marginBottom]="item.marginBottom !== undefined ? item.marginBottom : 40"
                        xAxisTitle="Entries"></app-horizontal-bar-chart>
                    }
                    @case ('admin-productivity') {
                    <app-vertical-single-bar [data]="adminProductivityData" [maxBars]="14" [barHeight]="200"
                        [showRankBadges]="false" valueKey="volume" labelKey="name" amountKey="yield" amountSuffix="/Arr"
                        [showSecondaryLabel]="false" valueFormat="number"
                        (viewAll)="handleAdminProductivityViewAll()"></app-vertical-single-bar>
                    }
                    @case ('duplicates-by-admin') {
                    <app-multiple-bar [data1]="duplicatesData" [data2]="deletionsData" valueKey="value" labelKey="label"
                        valueType="number" [showLegends]="true" [showDynamicxAxisLabel]="true"
                        [legendData]="[{ label: 'Total Duplicates', color: '#ff5a5f' }, { label: 'Total Deletion', color: '#3b82f6' }]"
                        [colors]="{ data1: '#ff5a5f', data2: '#3b82f6', data3: '', data4: '' }"
                        [legendPosition]="item.legendPosition || 'left'"
                        [legendGap]="item.legendGap || 80"></app-multiple-bar>
                    }
                    @case ('repeat-intensity') {
                    <app-line-chart [data1]="repeatArrangementTrendData" valueKey="value" [unit]="unit()"
                        [xAxisShowOnlyFirstLast]="true" [showYAxis]="true" [showXAxis]="true" [showYAxisGrid]="true"
                        primaryLineColor="#3b82f6" [showCircleStrokes]="true" [minHeight]="item.minHeight || 250"
                        [marginTop]="item.marginTop || 30" [marginBottom]="item.marginBottom || 40"
                        valueFormat="number"></app-line-chart>
                    }
                    }
                    } @else if (!isLoading(item.id)) {
                    <div
                        class="absolute inset-0 flex flex-col items-center justify-center text-slate-400 dark:text-slate-500 bg-slate-50/30 dark:bg-surface-0/20 rounded-xl backdrop-blur-[1px] border border-slate-100/50 dark:border-gray-800/30 transition-all duration-500">
                        <div class="relative mb-4 group">
                            <div
                                class="absolute inset-0 bg-blue-400 dark:bg-blue-600 blur-2xl opacity-10 group-hover:opacity-20 transition-opacity rounded-full">
                            </div>
                            <app-icon-v2 name="database" [size]="56"
                                class="relative opacity-30 dark:opacity-20 group-hover:scale-110 transition-transform duration-500"></app-icon-v2>
                        </div>
                        <p class="text-base font-bold text-slate-600 dark:text-slate-300 tracking-tight">No Data
                            Available</p>
                        <p
                            class="text-xs mt-1.5 text-slate-400 dark:text-slate-500 max-w-[200px] text-center leading-relaxed">
                            We couldn't find any records for the selected parameters.
                        </p>
                    </div>
                    }
                </div>
            </div>
        </div>
        }

        @if (showSection(SectionId.ADMIN_DUPLICATE_EXPOSURE)) {
        <div class="group relative" [ngClass]="getSectionColClass(SectionId.ADMIN_DUPLICATE_EXPOSURE)"
            [style.order]="sectionOrder(SectionId.ADMIN_DUPLICATE_EXPOSURE)">
            @if (!mixedMode() && canPinToCustomDashboard(SectionId.ADMIN_DUPLICATE_EXPOSURE)) {
            <button type="button"
                (click)="addToCustomDashboard(SectionId.ADMIN_DUPLICATE_EXPOSURE); $event.stopPropagation()"
                [disabled]="isAddingToCustomDashboard(SectionId.ADMIN_DUPLICATE_EXPOSURE)"
                class="group/pin absolute cursor-pointer top-2 right-2 z-30 inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full border shadow-sm text-[11px] font-medium whitespace-nowrap opacity-0 translate-y-[-2px] group-hover:opacity-100 group-hover:translate-y-0 focus-visible:opacity-100 focus-visible:translate-y-0 transition-all duration-200 disabled:cursor-default"
                [ngClass]="isAddedToCustomDashboard(SectionId.ADMIN_DUPLICATE_EXPOSURE)
        ? 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-rose-50 hover:text-rose-700 hover:border-rose-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800 dark:hover:bg-rose-900/30 dark:hover:text-rose-300 dark:hover:border-rose-800 !opacity-100 !translate-y-0'
        : 'bg-white/95 text-[#AD46FF] border-[#AD46FF]/30 hover:bg-violet-50 hover:border-[#AD46FF]/60 hover:shadow-md dark:bg-slate-800/95 dark:border-purple-500/40 dark:hover:bg-white/5'"
                [attr.aria-label]="isAddedToCustomDashboard(SectionId.ADMIN_DUPLICATE_EXPOSURE) ? 'Remove from My Custom Dashboard' : 'Add to My Custom Dashboard'"
                [title]="isAddedToCustomDashboard(SectionId.ADMIN_DUPLICATE_EXPOSURE) ? 'Click to remove from My Custom Dashboard' : 'Add to My Custom Dashboard'">
                @if (isAddingToCustomDashboard(SectionId.ADMIN_DUPLICATE_EXPOSURE)) {
                <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                </svg>
                <span>{{ isAddedToCustomDashboard(SectionId.ADMIN_DUPLICATE_EXPOSURE) ? 'Removing' : 'Adding'
                    }}&hellip;</span>
                } @else if (isAddedToCustomDashboard(SectionId.ADMIN_DUPLICATE_EXPOSURE)) {
                <svg class="shrink-0 block group-hover/pin:hidden" xmlns="http://www.w3.org/2000/svg" width="11"
                    height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 6 9 17l-5-5" />
                </svg>
                <svg class="shrink-0 hidden group-hover/pin:block" xmlns="http://www.w3.org/2000/svg" width="11"
                    height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                </svg>
                <span
                    class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[220px] group-hover/pin:ml-0 focus-visible:max-w-[220px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Remove
                    from Custom Dashboard</span>
                } @else {
                <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                    <path d="M12 5v14" />
                </svg>
                <span
                    class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[200px] group-hover/pin:ml-0 focus-visible:max-w-[200px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Pin
                    to Custom Dashboard</span>
                }
            </button>
            }

            @if (isLoadingDuplicatesByAdmin) {
            <div
                class="bg-white dark:bg-surface-2 rounded-[24px] border border-slate-200 dark:border-gray-700 shadow-sm animate-pulse mb-4 overflow-hidden mt-4">
                <div
                    class="px-6 py-5 flex justify-between items-center border-b border-slate-100 dark:border-gray-700/50">
                    <div class="space-y-2">
                        <div class="h-4 w-48 bg-slate-100 dark:bg-slate-700/50 rounded"></div>
                        <div class="h-3 w-64 bg-slate-100 dark:bg-slate-700/40 rounded"></div>
                    </div>
                    <div class="h-8 w-20 bg-slate-100 dark:bg-slate-700/40 rounded-xl"></div>
                </div>
                <div class="p-6 space-y-4">
                    @for (i of [1,2,3,4,5]; track i) {
                    <div class="flex items-center gap-4">
                        <div class="h-4 w-1/3 bg-slate-50 dark:bg-slate-700/30 rounded"></div>
                        <div class="h-4 w-1/3 bg-slate-50 dark:bg-slate-700/30 rounded"></div>
                        <div class="h-4 w-1/3 bg-slate-50 dark:bg-slate-700/30 rounded"></div>
                    </div>
                    }
                </div>
            </div>
            } @else {
            <div
                class="bg-white dark:bg-surface-2 rounded-[24px] border border-slate-200 dark:border-gray-700 shadow-sm dark:shadow-none overflow-hidden h-full">
                <div
                    class="px-6 py-5 flex justify-between items-center border-b border-slate-100 dark:border-gray-700/50 bg-white/50 dark:bg-surface-2/50 backdrop-blur-sm">
                    <div class="text-left">
                        <h3
                            class="text-base 2xl:text-lg font-bold text-slate-900 dark:text-white tracking-tight leading-none mb-1">
                            {{tableRow('exposure')!.title}}</h3>
                        <p class="text-[10px] 2xl:text-xs text-slate-500 dark:text-slate-400 font-medium">
                            {{tableRow('exposure')!.subtitle}}</p>
                    </div>
                </div>
                <div class="p-3 rounded-[14px]">
                    <app-scroll-table [tableData]="tableRow('exposure')!.data!"
                        [headers]="tableRow('exposure')!.headers!" [showHeading]="false"
                        [showTableWithBorderAndRadius]="true" [tableKey]="tableRow('exposure')!.tableKey!"
                        [maxHeight]="'400px'"
                        (fetchData)="openAdminDetails($event, tableRow('exposure')!.data!)"></app-scroll-table>
                </div>
            </div>
            }
        </div>
        }

        @if (showSection(SectionId.DETAILED_DUPLICATE_ANALYSIS)) {
        <div class="group relative" [ngClass]="getSectionColClass(SectionId.DETAILED_DUPLICATE_ANALYSIS)"
            [style.order]="sectionOrder(SectionId.DETAILED_DUPLICATE_ANALYSIS)">
            @if (!mixedMode() && canPinToCustomDashboard(SectionId.DETAILED_DUPLICATE_ANALYSIS)) {
            <button type="button"
                (click)="addToCustomDashboard(SectionId.DETAILED_DUPLICATE_ANALYSIS); $event.stopPropagation()"
                [disabled]="isAddingToCustomDashboard(SectionId.DETAILED_DUPLICATE_ANALYSIS)"
                class="group/pin absolute cursor-pointer top-2 right-2 z-30 inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full border shadow-sm text-[11px] font-medium whitespace-nowrap opacity-0 translate-y-[-2px] group-hover:opacity-100 group-hover:translate-y-0 focus-visible:opacity-100 focus-visible:translate-y-0 transition-all duration-200 disabled:cursor-default"
                [ngClass]="isAddedToCustomDashboard(SectionId.DETAILED_DUPLICATE_ANALYSIS)
        ? 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-rose-50 hover:text-rose-700 hover:border-rose-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800 dark:hover:bg-rose-900/30 dark:hover:text-rose-300 dark:hover:border-rose-800 !opacity-100 !translate-y-0'
        : 'bg-white/95 text-[#AD46FF] border-[#AD46FF]/30 hover:bg-violet-50 hover:border-[#AD46FF]/60 hover:shadow-md dark:bg-slate-800/95 dark:border-purple-500/40 dark:hover:bg-white/5'"
                [attr.aria-label]="isAddedToCustomDashboard(SectionId.DETAILED_DUPLICATE_ANALYSIS) ? 'Remove from My Custom Dashboard' : 'Add to My Custom Dashboard'"
                [title]="isAddedToCustomDashboard(SectionId.DETAILED_DUPLICATE_ANALYSIS) ? 'Click to remove from My Custom Dashboard' : 'Add to My Custom Dashboard'">
                @if (isAddingToCustomDashboard(SectionId.DETAILED_DUPLICATE_ANALYSIS)) {
                <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                </svg>
                <span>{{ isAddedToCustomDashboard(SectionId.DETAILED_DUPLICATE_ANALYSIS) ? 'Removing' : 'Adding'
                    }}&hellip;</span>
                } @else if (isAddedToCustomDashboard(SectionId.DETAILED_DUPLICATE_ANALYSIS)) {
                <svg class="shrink-0 block group-hover/pin:hidden" xmlns="http://www.w3.org/2000/svg" width="11"
                    height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 6 9 17l-5-5" />
                </svg>
                <svg class="shrink-0 hidden group-hover/pin:block" xmlns="http://www.w3.org/2000/svg" width="11"
                    height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                </svg>
                <span
                    class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[220px] group-hover/pin:ml-0 focus-visible:max-w-[220px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Remove
                    from Custom Dashboard</span>
                } @else {
                <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                    <path d="M12 5v14" />
                </svg>
                <span
                    class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[200px] group-hover/pin:ml-0 focus-visible:max-w-[200px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Pin
                    to Custom Dashboard</span>
                }
            </button>
            }

            @if (isLoadingDuplicatesByAdmin) {
            <div
                class="bg-white dark:bg-surface-2 rounded-[24px] border border-slate-200 dark:border-gray-700 shadow-sm animate-pulse mb-4 overflow-hidden mt-4">
                <div
                    class="px-6 py-5 flex justify-between items-center border-b border-slate-100 dark:border-gray-700/50">
                    <div class="space-y-2">
                        <div class="h-4 w-48 bg-slate-100 dark:bg-slate-700/50 rounded"></div>
                        <div class="h-3 w-64 bg-slate-100 dark:bg-slate-700/40 rounded"></div>
                    </div>
                    <div class="h-8 w-20 bg-slate-100 dark:bg-slate-700/40 rounded-xl"></div>
                </div>
                <div class="p-6 space-y-4">
                    @for (i of [1,2,3,4,5]; track i) {
                    <div class="flex items-center gap-4">
                        <div class="h-4 w-1/3 bg-slate-50 dark:bg-slate-700/30 rounded"></div>
                        <div class="h-4 w-1/3 bg-slate-50 dark:bg-slate-700/30 rounded"></div>
                        <div class="h-4 w-1/3 bg-slate-50 dark:bg-slate-700/30 rounded"></div>
                    </div>
                    }
                </div>
            </div>
            } @else {
            <div
                class="bg-white dark:bg-surface-2 rounded-[24px] border border-slate-200 dark:border-gray-700 shadow-sm dark:shadow-none overflow-hidden h-full">
                <div
                    class="px-6 py-5 flex justify-between items-center border-b border-slate-100 dark:border-gray-700/50 bg-white/50 dark:bg-surface-2/50 backdrop-blur-sm">
                    <div class="text-left">
                        <h3
                            class="text-base 2xl:text-lg font-bold text-slate-900 dark:text-white tracking-tight leading-none mb-1">
                            {{tableRow('detailed')!.title}}</h3>
                        <p class="text-[10px] 2xl:text-xs text-slate-500 dark:text-slate-400 font-medium">
                            {{tableRow('detailed')!.subtitle}}</p>
                    </div>
                </div>
                <div class="p-3 rounded-[14px]">
                    <app-scroll-table [tableData]="tableRow('detailed')!.data!"
                        [headers]="tableRow('detailed')!.headers!" [showHeading]="false"
                        [showTableWithBorderAndRadius]="true" [tableKey]="tableRow('detailed')!.tableKey!"
                        [maxHeight]="'400px'"
                        (fetchData)="openAdminDetails($event, tableRow('detailed')!.data!)"></app-scroll-table>
                </div>
            </div>
            }
        </div>
        }

        @for (yearSection of [
        { id: SectionId.WORST_YEAR, index: 0 },
        { id: SectionId.BEST_YEAR, index: 1 },
        { id: SectionId.LATEST_YEAR, index: 2 }
        ]; track yearSection.id) {
        @let card = yearSummaryAt(yearSection.index);
        @if (showSection(yearSection.id)) {
        <div class="group relative" [ngClass]="getSectionColClass(yearSection.id)"
            [style.order]="sectionOrder(yearSection.id)">
            @if (isLoadingYearlySummary) {
            <div
                class="bg-white dark:bg-surface-2 px-4 py-4 rounded-[20px] border border-slate-200 dark:border-gray-700 shadow-sm animate-pulse h-[200px]">
            </div>
            } @else if (card) {
            <div
                class="bg-white dark:bg-surface-2 px-4 py-4 2xl:px-5 2xl:py-5 rounded-[20px] border border-slate-200 dark:border-gray-700 shadow-sm dark:shadow-none hover:shadow-md dark:hover:shadow-none transition-all duration-300 text-left h-full">
                <div class="flex justify-between items-start gap-3 mb-6">
                    <div class="min-w-0">
                        <span
                            class="text-[10px] 2xl:text-[11px] text-slate-500 dark:text-slate-400 font-semibold uppercase tracking-wider">{{card.label}}</span>
                        <h2 class="text-2xl 2xl:text-3xl font-bold text-slate-900 dark:text-white mt-1 leading-none">
                            {{card.year}}</h2>
                    </div>
                    <div class="relative shrink-0">
                        @if (!mixedMode() && canPinToCustomDashboard(yearSection.id)) {
                        <button type="button" (click)="addToCustomDashboard(yearSection.id); $event.stopPropagation()"
                            [disabled]="isAddingToCustomDashboard(yearSection.id)"
                            class="group/pin absolute -top-1 right-0 z-40 cursor-pointer inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full border shadow-sm text-[11px] font-medium whitespace-nowrap opacity-0 translate-y-[-2px] group-hover:opacity-100 group-hover:translate-y-0 focus-visible:opacity-100 focus-visible:translate-y-0 transition-all duration-200 disabled:cursor-default pointer-events-none group-hover:pointer-events-auto focus-visible:pointer-events-auto"
                            [ngClass]="isAddedToCustomDashboard(yearSection.id)
                ? 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-rose-50 hover:text-rose-700 hover:border-rose-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800 dark:hover:bg-rose-900/30 dark:hover:text-rose-300 dark:hover:border-rose-800 !opacity-100 !translate-y-0 pointer-events-auto'
                : 'bg-white/95 text-[#AD46FF] border-[#AD46FF]/30 hover:bg-violet-50 hover:border-[#AD46FF]/60 hover:shadow-md dark:bg-slate-800/95 dark:border-purple-500/40 dark:hover:bg-white/5'"
                            [attr.aria-label]="isAddedToCustomDashboard(yearSection.id) ? 'Remove from My Custom Dashboard' : 'Add to My Custom Dashboard'"
                            [title]="isAddedToCustomDashboard(yearSection.id) ? 'Click to remove from My Custom Dashboard' : 'Add to My Custom Dashboard'">
                            @if (isAddingToCustomDashboard(yearSection.id)) {
                            <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="11" height="11"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                            </svg>
                            <span>{{ isAddedToCustomDashboard(yearSection.id) ? 'Removing' : 'Adding' }}&hellip;</span>
                            } @else if (isAddedToCustomDashboard(yearSection.id)) {
                            <svg class="shrink-0 block group-hover/pin:hidden" xmlns="http://www.w3.org/2000/svg"
                                width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M20 6 9 17l-5-5" />
                            </svg>
                            <svg class="shrink-0 hidden group-hover/pin:block" xmlns="http://www.w3.org/2000/svg"
                                width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M5 12h14" />
                            </svg>
                            <span
                                class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[220px] group-hover/pin:ml-0 focus-visible:max-w-[220px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Remove
                                from Custom Dashboard</span>
                            } @else {
                            <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path d="M5 12h14" />
                                <path d="M12 5v14" />
                            </svg>
                            <span
                                class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[200px] group-hover/pin:ml-0 focus-visible:max-w-[200px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Pin
                                to Custom Dashboard</span>
                            }
                        </button>
                        }
                        <span
                            [class]="'px-3 py-1 rounded-full text-[10px] font-bold flex items-center gap-1.5 ' + card.statusClass">
                            <span class="w-1.5 h-1.5 rounded-full bg-current"></span>
                            {{card.status}}
                        </span>
                    </div>
                </div>
                <div class="grid grid-cols-3 gap-2 2xl:gap-4 mb-6 pt-2">
                    <div>
                        <p class="text-[9px] 2xl:text-[10px] text-slate-400 font-bold uppercase tracking-widest mb-1.5">
                            Duplicates</p>
                        <p class="text-lg 2xl:text-xl font-bold text-slate-900 dark:text-white">{{card.duplicates}}</p>
                    </div>
                    <div>
                        <p class="text-[9px] 2xl:text-[10px] text-slate-400 font-bold uppercase tracking-widest mb-1.5">
                            Deletions</p>
                        <p class="text-lg 2xl:text-xl font-bold text-slate-900 dark:text-white">{{card.deletions}}</p>
                    </div>
                    <div>
                        <p class="text-[9px] 2xl:text-[10px] text-slate-400 font-bold uppercase tracking-widest mb-1.5">
                            Contracts</p>
                        <p class="text-lg 2xl:text-xl font-bold text-slate-900 dark:text-white">{{card.contracts}}</p>
                    </div>
                </div>
                <div class="flex items-center justify-between pt-4 border-t border-slate-100 dark:border-gray-700/50">
                    <span
                        class="text-xs 2xl:text-sm text-slate-500 dark:text-slate-400 font-medium whitespace-nowrap overflow-hidden text-ellipsis">Null
                        Entries: <span
                            class="font-bold text-slate-900 dark:text-white">{{card.nullEntries}}</span></span>
                    <div [class]="'flex items-center gap-1 text-[10px] 2xl:text-xs font-bold ' + card.trendClass">
                        <app-icon-v2 [name]="card.trendIcon" size="14"></app-icon-v2>
                        {{card.trend}}
                    </div>
                </div>
            </div>
            }
        </div>
        }
        }

    </div>
</div>

<app-dashboard-layout-editor [open]="isLayoutEditorOpen()" [items]="editorItems()" [visibleCount]="editorVisibleCount()"
    (closed)="closeLayoutEditor()" (applied)="applyLayoutEditor()" (resetDefaults)="resetLayoutEditorToDefaults()"
    (cardDropped)="onEditorCardDrop($any($event))" (visibilityToggled)="toggleEditorCardVisibility($any($event))"
    (colSpanDecreased)="decreaseEditorCardColSpan($any($event))"
    (colSpanIncreased)="increaseEditorCardColSpan($any($event))" (autoAdjustWidth)="autoAdjustEditorWidths()" />

<app-transaction-logs-panel [open]="isPanelOpen" [config]="panelConfig"
    (closed)="onClosePanel()"></app-transaction-logs-panel>

<ng-template #adminDetailsModal>
    <!-- Modal Dialog Container -->
    <div class="bg-white dark:bg-surface-0 rounded-[1.5rem] shadow-2xl flex flex-col overflow-hidden border border-[#efefef]/20 dark:border-[#efefef]/20 mx-auto backdrop-blur-md"
        style="width: 90vw; height: 85vh; max-width: 1400px;">

        <!-- Content Area -->
        <div
            class="flex-1 overflow-y-auto overflow-x-hidden w-full h-full [&::-webkit-scrollbar]:hidden [-ms-overflow-style:'none'] [scrollbar-width:'none']">
            @if(selectedAdminId) {
            <app-admin-details [adminId]="selectedAdminId" [adminList]="adminOptions"
                (closePanel)="dialog.closeAll()"></app-admin-details>
            } @else {
            <div class="p-12 text-center text-gray-500">Loading admin details...</div>
            }
        </div>
    </div>
</ng-template>